/* Tooltip container (question sign) */
.rv-tooltip {
  fill: currentcolor;
  color: #424242;
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 100%;

  .rv-tooltip-image {
    display: flex;
  }
}

/* Tooltip text */
.rv-tooltiptext {
  position: absolute;
  visibility: hidden;
  z-index: 1;
  user-select: none;
  width: 120px;
  max-width: 300px;
  padding: 4px 8px;
  margin: 4px;
  border-radius: 4px;
  background-color: rgb(97 97 97 / 92%);
  color: #fff;
  overflow-wrap: break-word;
  text-align: left;
  font-size: 11px;
  font-weight: 500;
}

/* Tooltip text positioning */
.rv-tooltiptext.rv-center-right {
  top: 0;
  left: 15px;
}

.rv-tooltiptext.rv-top-right {
  left: 15px;
}

.rv-tooltiptext.rv-center-left {
  top: 0;
  right: 15px;
}

.rv-tooltiptext.rv-top-left {
  right: 15px;
}

.rv-tooltiptext.rv-bottom-right {
  top: 24px;
  left: -2px;
}

.rv-tooltiptext.rv-bottom-left {
  top: 24px;
  right: -2px;
}

.rv-tooltiptext.rv-bottom-center {
  top: 24px;
  left: -60px;
}

/* Tooltip arrow base class */
.rv-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

/* Arrow positioning and direction */
.rv-tooltip-arrow-top {
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 5px 5px;
  border-color: transparent transparent var(--rv-tooltip-arrow-color, rgb(97 97 97 / 92%))
    transparent;
}

.rv-tooltip-arrow-bottom {
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px 5px 0;
  border-color: var(--rv-tooltip-arrow-color, rgb(97 97 97 / 92%)) transparent transparent
    transparent;
}

.rv-tooltip-arrow-left {
  top: 50%;
  left: -5px;
  transform: translateY(-50%);
  border-width: 5px 5px 5px 0;
  border-color: transparent var(--rv-tooltip-arrow-color, rgb(97 97 97 / 92%)) transparent
    transparent;
}

.rv-tooltip-arrow-right {
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  border-width: 5px 0 5px 5px;
  border-color: transparent transparent transparent
    var(--rv-tooltip-arrow-color, rgb(97 97 97 / 92%));
}

/* Show the tooltip text when you mouse over the tooltip container */
.rv-tooltip:hover,
.rv-tooltip:focus {
  .rv-tooltiptext {
    visibility: visible;
    display: inline-block;
    flex-shrink: 0;
  }
}
